import type { StreamRequestOptions } from "@src/cloud-connect/api/util/create-linked-abort-controller";
import {
  postSupportCommentWithAIStream,
  CommentStreamEvent,
} from "@src/cloud-connect/api/support/post-support-comment-with-ai-stream";
import store from "@src/reducers/store";
import { PostSupportCommentByTicketPayload } from "@src/types/support";

export type { CommentStreamEvent };

export async function* postSupportCommentWithAIStreamUseCase(
  ticketId: string | number,
  payload: PostSupportCommentByTicketPayload,
  options?: StreamRequestOptions,
  files?: File[],
): AsyncGenerator<CommentStreamEvent, void, void> {
  const namespace = store.getState().yourSlice.authContext.customerNamespace;

  yield* postSupportCommentWithAIStream(namespace, ticketId, payload, options, files);
}
